import createVueApp from '@/common/create_app'

Styxie.Initializers.AdminDocumentation = {
  index: async(props) => {
    const { default: DocumentationApp } = await import('@/vue_widgets/documentation/index.vue')
    // noPadding: the page paints its own gray canvas edge-to-edge.
    createVueApp(DocumentationApp, { props, layoutProps: { noPadding: true } })
  }
}
